/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Rooms_Error_SaveInputs */



/**
* | output |
* | --- |
* | "Couldn't save rooms." |
*
* @param {Table_Rooms_Error_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const table_rooms_error_save = /** @type {((inputs?: Table_Rooms_Error_SaveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Rooms_Error_SaveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer les salles.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron guardar las salas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível salvar as salas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare le sale.")
	return /** @type {LocalizedString} */ ("Couldn't save rooms.")
});